var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',[_c('use',{attrs:{"href":'/sprite.svg#' + _vm.name}})])
}
var staticRenderFns = []

export { render, staticRenderFns }